import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { BaseModalModule } from '../base-modal.module';
import { AssignSupportModalComponent } from './assign-support-modal.component';
import { AssignSupportModalService } from './assign-support-modal.service';

@NgModule({
  declarations: [AssignSupportModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    BaseModalModule,
    MatDialogModule,
  ],
  exports: [AssignSupportModalComponent],
  providers: [AssignSupportModalService],
  entryComponents: [AssignSupportModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssignSupportModalModule {}
